(function () {
  'use strict';

  function pad(n) {
    return n < 10 ? '0' + n : '' + n;
  }

  function parseSaleDate(value) {
    if (!value) return null;
    var parts = value.trim().split(/\s+/);
    var date = (parts[0] || '').split('-');
    var time = (parts[1] || '00:00').split(':');
    var day = parseInt(date[0], 10);
    var month = parseInt(date[1], 10);
    var year = parseInt(date[2], 10);
    if (!day || !month || !year) return null;
    var hours = parseInt(time[0], 10) || 0;
    var minutes = parseInt(time[1], 10) || 0;
    var seconds = parseInt(time[2], 10) || 0;
    return new Date(year, month - 1, day, hours, minutes, seconds);
  }

  function initCountdowns() {
    var nodes = document.querySelectorAll('[data-sale-countdown]');
    Array.prototype.forEach.call(nodes, function (el) {
      var end = parseSaleDate(el.getAttribute('data-end'));
      if (!end) return;

      var daysEl = el.querySelector('[data-days]');
      var hoursEl = el.querySelector('[data-hours]');
      var minutesEl = el.querySelector('[data-minutes]');
      var secondsEl = el.querySelector('[data-seconds]');

      function tick() {
        var diff = Math.floor((end.getTime() - Date.now()) / 1000);
        if (diff < 0) diff = 0;
        var days = Math.floor(diff / 86400);
        var hours = Math.floor((diff % 86400) / 3600);
        var minutes = Math.floor((diff % 3600) / 60);
        var seconds = diff % 60;
        if (daysEl) daysEl.textContent = pad(days);
        if (hoursEl) hoursEl.textContent = pad(hours);
        if (minutesEl) minutesEl.textContent = pad(minutes);
        if (secondsEl) secondsEl.textContent = pad(seconds);
        if (diff === 0) clearInterval(timer);
      }

      tick();
      var timer = setInterval(tick, 1000);
    });
  }

  function initPopup() {
    var popup = document.querySelector('[data-sale-popup]');
    if (!popup) return;

    var delay = (parseFloat(popup.getAttribute('data-delay')) || 0) * 1000;
    var duration = (parseFloat(popup.getAttribute('data-duration')) || 8) * 1000;
    var frequency = (parseFloat(popup.getAttribute('data-frequency')) || 0) * 1000;
    var closeBtn = popup.querySelector('.sale-popup__close');
    var hideTimer;
    var cycleTimer;
    var dismissed = false;

    function show() {
      if (dismissed) return;
      popup.hidden = false;
      void popup.offsetWidth;
      popup.classList.add('is-visible');
      clearTimeout(hideTimer);
      hideTimer = setTimeout(hide, duration);
    }

    function hide() {
      popup.classList.remove('is-visible');
    }

    function dismiss() {
      dismissed = true;
      clearTimeout(hideTimer);
      clearInterval(cycleTimer);
      hide();
    }

    popup.addEventListener('transitionend', function () {
      if (!popup.classList.contains('is-visible')) popup.hidden = true;
    });

    if (closeBtn) closeBtn.addEventListener('click', dismiss);

    setTimeout(function () {
      show();
      if (frequency > 0) {
        cycleTimer = setInterval(show, frequency);
      }
    }, delay);
  }

  function init() {
    initCountdowns();
    initPopup();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
